var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.99975 4.35903L2.41427 6.94451C2.02374 7.33504 1.46972 7.41418 1.17683 7.12129C0.883935 6.8284 0.963081 6.27438 1.35361 5.88385L4.18203 3.05542C4.42532 2.81213 4.73207 2.68969 4.9996 2.70277C5.2672 2.68959 5.57408 2.81203 5.81746 3.05541L8.64589 5.88384C9.03641 6.27436 9.11556 6.82838 8.82266 7.12127C8.52977 7.41417 7.97575 7.33502 7.58523 6.9445L4.99975 4.35903Z",
    fill: "#082A51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowUp);
export default __webpack_public_path__ + "static/media/icon-arrow-up.26c7e7bca8355538c6d2921a7c3e04a6.svg";
export { ForwardRef as ReactComponent };